<script setup lang="ts">
import ToastContainer from '@/components/ToastContainer.vue';
import { useUiStore } from '@/stores/ui';

// Activa el tema (y su cambio automatico por horario) en todas las paginas,
// tambien en el ingreso.
useUiStore();
</script>

<template>
  <router-view v-slot="{ Component, route }">
    <transition name="route-fade" mode="out-in">
      <component :is="Component" :key="route.fullPath" />
    </transition>
  </router-view>
  <ToastContainer />
</template>
